const state = {
  tasksStore:
    [
      {
        id: 1,
        title_en: "Anagram",
        title_ua: "Анаграма",
        title_es: "Anagrama",
        url: { name: "anagram" },
      },
      {
        id: 2,
        title_en: "Fibonacci",
        title_ua: "Фібоначчі",
        title_es: "Fibonacci",
        url: { name: "fibonacci" },
      },
      {
        id: 3,
        title_en: "Find vowels",
        title_ua: "Знайди голосні",
        title_es: "Encontrar vocales",
        url: { name: "findvowels" },
      },
      {
        id: 4,
        title_en: "FizzBuzz",
        title_ua: "FizzBuzz",
        title_es: "FizzBuzz",
        url: { name: "fizzbuzz" },
      },
      {
        id: 5,
        title_en: "Palindrome",
        title_ua: "Паліндром",
        title_es: "Palíndromo",
        url: { name: "palindrome" },
      }
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};